module.exports = __webpack_public_path__ + "static/media/ep-logo-white.2f375c93.svg";